module.exports = __webpack_public_path__ + "img/meet.bf8b1f7a.svg";